/* Two Guys One Couch — theme.js
   Small, dependency-free behaviours. Everything degrades gracefully without JS. */
(function () {
  'use strict';

  var on = function (el, evt, fn) { if (el) el.addEventListener(evt, fn); };
  var $ = function (sel, root) { return (root || document).querySelector(sel); };
  var $$ = function (sel, root) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); };

  /* ---------------- Announcement rotator ---------------- */
  function initAnnouncement() {
    $$('[data-announcement]').forEach(function (bar) {
      var items = $$('.announcement__item', bar);
      if (items.length < 2) return;
      var i = 0;
      var speed = parseInt(bar.getAttribute('data-speed'), 10) || 5000;
      var timer = null;

      function show(n) {
        items[i].classList.remove('is-active');
        i = (n + items.length) % items.length;
        items[i].classList.add('is-active');
      }
      function start() { timer = setInterval(function () { show(i + 1); }, speed); }
      function stop() { clearInterval(timer); }

      on($('[data-announcement-prev]', bar), 'click', function () { stop(); show(i - 1); start(); });
      on($('[data-announcement-next]', bar), 'click', function () { stop(); show(i + 1); start(); });
      on(bar, 'mouseenter', stop);
      on(bar, 'mouseleave', start);
      start();
    });
  }

  /* ---------------- Mobile menu ---------------- */
  function initMobileMenu() {
    var menu = $('[data-mobile-menu]');
    if (!menu) return;
    function open() { menu.classList.add('is-open'); document.body.style.overflow = 'hidden'; }
    function close() { menu.classList.remove('is-open'); document.body.style.overflow = ''; }

    $$('[data-menu-open]').forEach(function (b) { on(b, 'click', open); });
    $$('[data-menu-close]').forEach(function (b) { on(b, 'click', close); });
    on(menu, 'click', function (e) { if (e.target === menu) close(); });
    on(document, 'keydown', function (e) { if (e.key === 'Escape') close(); });
  }

  /* ---------------- Product gallery ---------------- */
  function initGallery() {
    $$('[data-gallery]').forEach(function (gallery) {
      var slides = $$('.gallery__slide', gallery);
      var thumbs = $$('.gallery__thumb', gallery);
      if (!slides.length) return;
      var index = 0;

      function go(n) {
        index = (n + slides.length) % slides.length;
        slides.forEach(function (s, k) { s.classList.toggle('is-active', k === index); });
        thumbs.forEach(function (t, k) { t.setAttribute('aria-current', k === index ? 'true' : 'false'); });
        var active = thumbs[index];
        if (active && active.scrollIntoView) {
          active.scrollIntoView({ block: 'nearest', inline: 'nearest', behavior: 'smooth' });
        }
      }

      thumbs.forEach(function (t, k) { on(t, 'click', function () { go(k); }); });
      on($('[data-gallery-prev]', gallery), 'click', function () { go(index - 1); });
      on($('[data-gallery-next]', gallery), 'click', function () { go(index + 1); });

      // Jump the gallery to the image of a newly selected variant.
      document.addEventListener('variant:change', function (e) {
        var id = e.detail && e.detail.mediaId;
        if (!id) return;
        var match = slides.findIndex ? slides.findIndex(function (s) { return s.getAttribute('data-media-id') === String(id); }) : -1;
        if (match > -1) go(match);
      });
    });
  }

  /* ---------------- Quantity steppers ---------------- */
  function initQuantity() {
    $$('[data-qty]').forEach(function (wrap) {
      var input = $('input', wrap);
      if (!input) return;
      $$('[data-qty-change]', wrap).forEach(function (btn) {
        on(btn, 'click', function () {
          var step = parseInt(btn.getAttribute('data-qty-change'), 10);
          var min = parseInt(input.getAttribute('min'), 10) || 1;
          var next = (parseInt(input.value, 10) || min) + step;
          input.value = next < min ? min : next;
          input.dispatchEvent(new Event('change', { bubbles: true }));
        });
      });
    });
  }

  /* ---------------- Financing (Affirm) ----------------
     Affirm's script rewrites any `.affirm-as-low-as` element it finds. We keep
     its `data-amount` in step with the selected variant and ask it to re-render.
     If the script never loads, the reserved slot collapses so no empty box is
     left behind. */
  var affirmTimer;
  function refreshAffirm() {
    clearTimeout(affirmTimer);
    affirmTimer = setTimeout(function () {
      try {
        if (window.affirm && window.affirm.ui && typeof window.affirm.ui.refresh === 'function') {
          window.affirm.ui.refresh();
        }
      } catch (e) { /* Affirm not present — the slot hides itself below */ }
    }, 120);
  }

  function setFinancingAmount(root, cents) {
    var slot = (root || document).querySelector('[data-affirm-slot]');
    if (!slot) return;
    slot.setAttribute('data-amount', cents);
    refreshAffirm();
  }

  function initFinancing() {
    var slots = $$('[data-financing]');
    if (!slots.length) return;
    refreshAffirm();

    // Give the script a fair chance, then collapse anything still empty.
    function settle() {
      slots.forEach(function (slot) {
        var msg = $('[data-affirm-slot]', slot);
        var rendered = msg && (msg.textContent.trim() !== '' || msg.querySelector('img, svg, a'));
        var fallback = $('[data-financing-fallback]', slot);
        if (rendered) {
          if (fallback) fallback.hidden = true;
          slot.classList.remove('is-empty');
        } else if (!fallback) {
          slot.classList.add('is-empty');
        }
      });
    }
    setTimeout(settle, 1200);
    setTimeout(settle, 4000);
  }

  /* ---------------- Variant picker ---------------- */
  function initVariants() {
    $$('[data-product-form]').forEach(function (form) {
      var dataEl = $('[data-variants]', form.closest('[data-product-root]') || document);
      if (!dataEl) return;

      var variants;
      try { variants = JSON.parse(dataEl.textContent); } catch (err) { return; }

      var root = form.closest('[data-product-root]');
      var idInput = $('[data-variant-id]', form);
      var addBtn = $('[data-add-button]', form);
      var priceEl = $('[data-price-now]', root);
      var compareEl = $('[data-price-compare]', root);
      var saveEl = $('[data-price-save]', root);
      var skuEl = $('[data-sku]', root);
      var stockEl = $('[data-stock]', root);
      var moneyFormat = root.getAttribute('data-money-format') || '${{amount}}';

      function money(cents) {
        var amount = (cents / 100).toFixed(2);
        var parts = amount.split('.');
        parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
        return moneyFormat.replace(/\{\{\s*amount\s*\}\}/, parts.join('.'));
      }

      // The option inputs sit outside <form>, associated by their form="" attribute.
      // form.elements includes those; form.querySelectorAll does NOT — using the
      // latter silently found nothing and the picker never updated.
      function optionInputs() {
        return Array.prototype.filter.call(form.elements, function (el) {
          return el.hasAttribute && el.hasAttribute('data-option-index');
        });
      }

      function selectedOptions() {
        return optionInputs()
          .filter(function (el) { return el.checked || el.tagName === 'SELECT'; })
          .reduce(function (acc, el) {
            acc[parseInt(el.getAttribute('data-option-index'), 10)] = el.value;
            return acc;
          }, []);
      }

      function findVariant(opts) {
        return variants.find(function (v) {
          return opts.every(function (val, k) { return val === undefined || v.options[k] === val; });
        });
      }

      function disableUnavailable(opts) {
        // Grey out option values that produce no purchasable variant.
        optionInputs().forEach(function (input) {
          if (input.tagName === 'SELECT') return;
          var k = parseInt(input.getAttribute('data-option-index'), 10);
          var trial = opts.slice();
          trial[k] = input.value;
          var match = variants.find(function (v) {
            return trial.every(function (val, j) { return j === k ? v.options[j] === input.value : (val === undefined || v.options[j] === val); });
          });
          input.disabled = !match || !match.available;
        });
      }

      function update() {
        var opts = selectedOptions();
        var variant = findVariant(opts);
        disableUnavailable(opts);

        if (!variant) {
          if (addBtn) { addBtn.disabled = true; addBtn.textContent = addBtn.getAttribute('data-unavailable-text') || 'Unavailable'; }
          return;
        }

        if (idInput) idInput.value = variant.id;

        if (priceEl) priceEl.textContent = money(variant.price);
        if (compareEl) {
          if (variant.compare_at_price && variant.compare_at_price > variant.price) {
            compareEl.hidden = false;
            var s = $('s', compareEl);
            if (s) s.textContent = money(variant.compare_at_price);
          } else {
            compareEl.hidden = true;
          }
        }
        if (saveEl) {
          if (variant.compare_at_price && variant.compare_at_price > variant.price) {
            saveEl.hidden = false;
            saveEl.textContent = (saveEl.getAttribute('data-label') || 'Save') + ' ' + money(variant.compare_at_price - variant.price);
          } else {
            saveEl.hidden = true;
          }
        }
        if (skuEl && variant.sku) skuEl.textContent = variant.sku;

        setFinancingAmount(root, variant.price);

        if (stockEl) {
          stockEl.hidden = !(variant.available && variant.inventory_management && variant.inventory_quantity > 0 && variant.inventory_quantity <= 5);
          if (!stockEl.hidden) {
            stockEl.querySelector('[data-stock-count]').textContent = variant.inventory_quantity;
          }
        }

        if (addBtn) {
          addBtn.disabled = !variant.available;
          addBtn.textContent = variant.available
            ? (addBtn.getAttribute('data-add-text') || 'Add to cart')
            : (addBtn.getAttribute('data-soldout-text') || 'Sold out');
        }

        // Keep the URL shareable.
        if (history.replaceState) {
          var url = new URL(window.location.href);
          url.searchParams.set('variant', variant.id);
          history.replaceState({}, '', url.toString());
        }

        document.dispatchEvent(new CustomEvent('variant:change', { detail: { variant: variant, mediaId: variant.featured_media_id } }));
      }

      optionInputs().forEach(function (el) { on(el, 'change', update); });
      update();
    });
  }

  /* ---------------- Delivery add-on (line item property) ---------------- */
  function initDeliveryPicker() {
    $$('[data-delivery-picker]').forEach(function (picker) {
      var out = $('[data-delivery-summary]', picker.closest('[data-product-root]') || document);
      function sync() {
        var checked = $('input:checked', picker);
        if (checked && out) out.textContent = checked.getAttribute('data-summary') || '';
      }
      $$('input', picker).forEach(function (i) { on(i, 'change', sync); });
      sync();
    });
  }

  /* ---------------- Condition legend modal ---------------- */
  function initModals() {
    $$('[data-modal-open]').forEach(function (btn) {
      on(btn, 'click', function () {
        var dlg = document.getElementById(btn.getAttribute('data-modal-open'));
        if (dlg && dlg.showModal) dlg.showModal();
      });
    });
    $$('[data-modal-close]').forEach(function (btn) {
      on(btn, 'click', function () {
        var dlg = btn.closest('dialog');
        if (dlg) dlg.close();
      });
    });
  }

  /* ---------------- Sticky add-to-cart (mobile) ---------------- */
  function initStickyAtc() {
    var bar = $('[data-sticky-atc]');
    var anchor = $('[data-atc-anchor]');
    if (!bar || !anchor || !('IntersectionObserver' in window)) return;
    new IntersectionObserver(function (entries) {
      bar.classList.toggle('is-visible', !entries[0].isIntersecting);
    }, { rootMargin: '0px 0px -60px 0px' }).observe(anchor);
  }

  /* ---------------- Facet auto-submit ---------------- */
  function initFacets() {
    $$('[data-auto-submit]').forEach(function (form) {
      $$('input, select', form).forEach(function (el) {
        on(el, 'change', function () { form.submit(); });
      });
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    initAnnouncement();
    initMobileMenu();
    initGallery();
    initQuantity();
    initVariants();
    initFinancing();
    initDeliveryPicker();
    initModals();
    initStickyAtc();
    initFacets();
  });
})();